var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cq-header d-flex justify-content-between align-items-center"},[_c('router-link',{attrs:{"to":"/","id":"link_header_auth_logo"}},[_c('div',{staticClass:"cq-header-logo"},[_c('img',{staticClass:"img-contain",attrs:{"src":require("../assets/img/cq-logo.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }